module.exports = __webpack_public_path__ + "img/android.0b8c0e2c.png";